"use client";

import { c as _c } from "react/compiler-runtime";
import { Center, Loader } from "@mantine/core";
import classes from "./centered-page-loader.module.css";
type CenteredPageLoaderProps = {
  /**
   * Fill the viewport when the app layout (sidebar) is not mounted yet,
   * e.g. during the auth check before a protected page renders.
   */
  fullScreen?: boolean;
};

/**
 * The single, theme-accented page loader used across the app. Keeping every
 * page-level spinner identical (same shape, colour, centering) prevents the
 * loader from visibly "swapping" as the auth check, route and data resolve.
 */
export function CenteredPageLoader(t0) {
  const $ = _c(3);
  const {
    fullScreen: t1
  } = t0;
  const fullScreen = t1 === undefined ? false : t1;
  const t2 = fullScreen ? classes.fullScreen : classes.fill;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Loader size={48} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <Center className={t2}>{t3}</Center>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}